import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../service-ui/message.service';
import { StartupService } from '../service-ui/startup.service';
import { AbstractDataService } from "./abstract-data.service";
import {ManufacturingResourceBucket} from "../../model/ManufacturingResourceBucket";

@Injectable()
export class ManufacturingResourceBucketService extends AbstractDataService<ManufacturingResourceBucket> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService) {
    super(httpa, messageServicea, startupServicea);
  }

  makeObjectInstance(args: any): ManufacturingResourceBucket {
    const object = new ManufacturingResourceBucket(args);
    return object;
  }

  getLoggingObjectTypeName (): string {
    return "ManufacturingResourceBucket";
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint (): string {
    return "manufacturingresourcebucket";
  }
}
